import React from 'react';
import { useParams } from 'react-router-dom';
import { HeaderTemplate, Stepper, TitleHeader } from 'web-library';
import ReviewApplication from '../../../modules/accessArrangment/components/candidate/ReviewApplication/ReviewApplication';
import ReviewAmendment from '../../../modules/accessArrangment/components/candidate/ReviewApplication/ReviewAmendment';

interface SelectConditionPageProps {
  routeSteps: { label: string }[];
  activeStep: number;
  title: string;
}

const SelectConditionPage = ({ routeSteps, activeStep, title }: SelectConditionPageProps) => {
  const { mode } = useParams<{ mode: string }>();

  return (
    <>
      <TitleHeader title={title} />
      <HeaderTemplate>
        <Stepper activeStep={activeStep} steps={routeSteps} />
      </HeaderTemplate>
      {mode === 'draft' ? <ReviewApplication /> : <ReviewAmendment />}
    </>
  );
};

export default SelectConditionPage;
